import React from "react";

const OrdersDesktop = React.lazy(() => import("./ui/Orders"));

export const OrdersPage = () => {
  return <OrdersDesktop />;
};
